"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function ScrollIntoAreaTarget() {
	const pathname = usePathname();

	useEffect(() => {
		const target = document.getElementById(pathname.replace("/compliance/", ""));
		if (target !== null) target.parentElement?.scroll({ left: target.offsetLeft - 30 });
	}, [pathname]);

	return null;
}
